import React, {useState, useEffect} from 'react';
import NavBar from './commonHooks/commonHooks.navBar';
import DataService from '../service/service.sql';
import LogsViewer from './commonHooks/commonHooks.logViewer'

const FriendsLogs = () => {
    const [data, setData] = useState(null);
 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
        
                const username = urlParams.get('friend');

                const store = await DataService.friendsGetDb({friendReceived: username});
                setData(store.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return(
        <>
            <NavBar/>
            {data && <LogsViewer dat={data} />}
        </>
    )
}

export default FriendsLogs